module.exports = __webpack_public_path__ + "static/media/teacher.d0d84b69.svg";